import { Sender } from "@ant-design/x";
import styled from "styled-components";

export const StyledSender = styled(Sender)`
  .ant-sender-input {
    max-height: 1.6rem !important;
    overflow-y: auto !important;
    font-size: 1rem;

    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: rgb(234, 237, 240);
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 0.25rem;
    }
  }
`;
